export default "__VITE_ASSET__35a2dd66__"